$(document).ready(function () {
    /*show searchPreview on input focus event*/
    $('.headerSearch__input').on('focus', function (e) {
        $(this).closest('.headerSearch_new').find('.searchPreview').addClass('show');
    });

    /*close searchPreview by click on other area (except headerSearch)*/
    $(document).mouseup( function(e){ // событие клика по веб-документу
        var searchBlock = $('.headerSearch.headerSearch_new');
        if ( !searchBlock.is(e.target) // если клик был не по нашему блоку
            && searchBlock.has(e.target).length === 0 ) { // и не по его дочерним элементам
            searchBlock.find('.searchPreview').removeClass('show'); // скрываем его
        }
    });

    /*show or hide reset-btn on input event*/
    $(document).on('input keyup keydown focusin focusout', '.headerSearch__input', function (e) {
        if (!$(this).val()) {
            $(this).closest('.headerSearch_new').find('.headerSearch__btn_reset').removeClass('show');
        } else {
            $(this).closest('.headerSearch_new').find('.headerSearch__btn_reset').addClass('show');
        }
    });

    $(document).on('click','.headerSearch__btn_reset', function(){
        $(this).removeClass('show');
        $('.headerSearch__input').val('');
    });

    /*clean search history*/
    $('.cleanHistoryBtn').on('click', function () {
        $(this).closest('.searchPreview__title.searchPreview__title_history').next('.searchPreview__list.searchPreview__list_history').remove();
        $(this).closest('.searchPreview__title.searchPreview__title_history').remove();
    });

    /*clean search history-item*/
    $('.deleteHistoryItem').on('click', function () {
        $(this).closest('.searchPreview__item').remove();
    });
});

/*search mobile*/
(function () {
    $(document).ready(function () {
        const btnSearchMobile = $('#btnSearchMobile');
        const searchMobileWrap = $('#searchMobile');
        const searchMobile = searchMobileWrap.find($('.headerSearch.headerSearch_new'));
        const searchCancel = $('.searchCancelBtn');

        const btnHamburger = $('#h-hamburger');
        const menuMobile = $('#h-menu-mobile');
        const sCatalogMenuMobile = $('#catalog-menu-mobile');
        const body = $('body');
        const sCatalogMenuMobile_btnHeader = $('#s-menu-catalog-mobile-btn-header');
        const sCatalogMenuMobile_btnBottom = $('#s-menu-catalog-mobile-btn-bottom');

        /*open search mobile*/
        btnSearchMobile.on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('search-mobile-open')) {
                searchMobile.removeClass('mobile-active');
                searchMobileWrap.removeClass('active');
                $this.removeClass('search-mobile-open');
                body.removeClass('search-mobile-open');
                body.removeClass('overflowY_hidden');
            } else {

                /*if mobile burger-menu was opened before - close it*/
                if (body.hasClass('menu-mobile-open')) {
                    menuMobile.removeClass('active');
                    btnHamburger.removeClass('menu-mobile-open');
                    body.removeClass('menu-mobile-open');
                    body.removeClass('overflowY_hidden');
                }

                /*if mobile catalog-menu was opened before - close it*/
                if ($('body').hasClass('s-menu-catalog-mobile-open')) {
                    sCatalogMenuMobile.removeClass('active');
                    sCatalogMenuMobile_btnHeader.removeClass('s-menu-catalog-mobile-open');
                    sCatalogMenuMobile_btnBottom.removeClass('s-menu-catalog-mobile-open');
                    btnHamburger.removeClass('s-menu-catalog-mobile-open');
                    body.removeClass('s-menu-catalog-mobile-open');
                    body.removeClass('overflowY_hidden');
                }

                body.addClass('search-mobile-open');
                body.addClass('overflowY_hidden');
                $this.addClass('menu-mobile-open');
                searchMobileWrap.addClass('active');
                searchMobile.addClass('mobile-active');
            }
        });

        /*close search mobile*/
        searchCancel.on('click', function () {
            searchMobile.removeClass('mobile-active');
            searchMobileWrap.removeClass('active');
            btnSearchMobile.removeClass('search-mobile-open');
            body.removeClass('search-mobile-open');
            body.removeClass('overflowY_hidden');
        });
    });
})();
